import { CAPTCHA_KEY, getCaptchaToken } from '../iframe/captchaHelper';
import { clearApiClient } from './clearApiClient';

interface PaymentIntentResponse {
  stripe_payment_intent_id: string;
  stripe_payment_intent_client_secret: string;
  requires_action: boolean;
  success: boolean;
}

export const sendPaymentIntentRequest = (paymentMethodId: string, email: string, productId: string, coupon?: string) =>
  getCaptchaToken().then(
    (captchaToken) =>
      clearApiClient.post<PaymentIntentResponse>('/web/v1/store/stripe/payment-intent/create', {
        product_id: productId,
        email,
        stripe_payment_method_id: paymentMethodId,
        coupon,
        recaptcha_token: captchaToken,
        recaptcha_site_key: CAPTCHA_KEY,
      }),
    (err: unknown) => {
      throw err;
    },
  );

interface PaymentIntentSetupResponse {
  stripe_payment_setup_intent_id: string;
  stripe_payment_setup_intent_client_secret: string;
  requires_action: boolean;
  success: boolean;
}

export const sendPaymentSetupIntentRequest = (
  paymentMethodId: string,
  email: string,
  productId: string,
  coupon?: string,
) =>
  getCaptchaToken().then(
    (captchaToken) =>
      clearApiClient.post<PaymentIntentSetupResponse>('/web/v1/store/stripe/payment-setup-intent/create', {
        product_id: productId,
        email,
        stripe_payment_method_id: paymentMethodId,
        coupon,
        recaptcha_token: captchaToken,
        recaptcha_site_key: CAPTCHA_KEY,
      }),
    (err: unknown) => {
      throw err;
    },
  );

export const sendPaymentIntentConfirmRequest = (paymentIntentId: string) =>
  clearApiClient.post<{ success: boolean }>('/web/v1/store/stripe/payment-intent/confirm', {
    payment_intent_id: paymentIntentId,
  });

export interface CreateSubscriptionParams {
  product_id: string;
  payment_method: string;
  billing_email: string;
  stripe_payment_method_id: string;
  stripe_payment_intent_id: string;
}

export const sendCreateSubscriptionRequest = (
  params: CreateSubscriptionParams,
  successRedirectUrl: string,
  analyticsMetadata: Record<string, string | undefined>,
) =>
  clearApiClient.post<{ subscription_id: string }>('/web/v1/store/subscription/create', {
    ...params,
    success_redirect_url: successRedirectUrl,
    analytics_metadata: analyticsMetadata,
  });
